export const formatByteSize = (bytes: number): string | number => {
  if (!bytes) return '';
  if (!Number.isFinite(bytes)) return bytes;

  if (bytes <= 240000) return bytes;

  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let index = 0;
  let size = bytes;

  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index++;
  }

  const rounded = parseFloat(size.toFixed(2));
  return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(2)} ${units[index]}`;
};
